const createSliderBreakpoints = (min, max, step) => {
  const sliderStepsObject = {}
  for (let i = min; i <= max; i++) {
    if (i === min || i === max) sliderStepsObject[i] = i.toString()
    else if (i % step === 0) sliderStepsObject[i] = ''
  }
  return sliderStepsObject
}

const stringToColour = (str) => {
  let hash = 0
  str.split('').forEach((letter) => {
    hash = letter.charCodeAt(0) + ((hash << 5) - hash)
  })
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF
    colour += ('00' + value.toString(16)).substr(-2)
  }
  return colour
}

/*
 * The router guard stashes the originally requested URL in ?next= so a deep
 * link from another system survives the login round-trip. That value reaches
 * $router.push, so it has to be constrained to a path on this origin --
 * otherwise anyone could hand out /login?next=https://evil.example and turn
 * the login page into an open redirect.
 *
 * Accepts only a single-slash-rooted path. Rejects absolute URLs,
 * protocol-relative //host paths, backslash variants that some browsers
 * normalise to //, and anything that is not a string.
 */
const safeRedirectPath = (candidate, fallback = null) => {
  const value = Array.isArray(candidate) ? candidate[0] : candidate
  if (typeof value !== 'string') return fallback
  const trimmed = value.trim()
  const isRootedPath = trimmed.startsWith('/')
  const isProtocolRelative = /^[/\\]{2}/.test(trimmed)
  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed)
  if (!isRootedPath || isProtocolRelative || hasScheme) return fallback
  return trimmed
}

export default {
  createSliderBreakpoints,
  stringToColour,
  safeRedirectPath
}
